import React from 'react';
import { ageFromDob } from '../../../utils/labTestUtils';
import { displayPatientCode } from '../../../utils/patientCode';
import Icon from '../../Icon';

export default function PatientSearchStep({
  currentStep,
  selectedPatient,
  setSelectedPatient,
  patientQuery,
  setPatientQuery,
  patientResults,
  searchLoading,
  showDropdown,
  setShowDropdown,
  searchRef,
  setError,
}) {
  const selectedCode = displayPatientCode(selectedPatient?.patientCode);
  const selectedAge  = ageFromDob(selectedPatient?.dateOfBirth);
  return (
    <div
      className="form-section fade-in-up delay-1"
      style={{
        overflow: 'visible',
        position: 'relative',
        zIndex: showDropdown ? 50 : 'auto',
      }}
    >
      <div className="form-section-title">
        <span className={`lab-step-badge${currentStep > 1 ? ' is-done' : ''}`}>1</span>
        Select patient
      </div>
      <div className="form-section-subtitle">
        Search by name or phone to find who this home collection is for.
      </div>

      {selectedPatient ? (
        <div className="lab-patient-card">
          <div className="lab-patient-avatar">
            {selectedPatient.firstName?.[0]}{selectedPatient.lastName?.[0]}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--text-primary)' }}>
              {selectedPatient.firstName} {selectedPatient.lastName}
            </div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 3 }}>
              {selectedCode && <span className="mono">{selectedCode}</span>}
              {selectedPatient.gender && `${selectedCode ? ' · ' : ''}${selectedPatient.gender}`}
              {selectedAge != null && `${selectedCode || selectedPatient.gender ? ' · ' : ''}${selectedAge} yrs`}
            </div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>
              {selectedPatient.phone && `📞 ${selectedPatient.phone}`}
              {selectedPatient.email && ` · ✉️ ${selectedPatient.email}`}
            </div>
          </div>
          <button
            type="button"
            className="btn btn-ghost btn-sm"
            onClick={() => { setSelectedPatient(null); setPatientQuery(''); }}
          >
            ✕ Change
          </button>
        </div>
      ) : (
        <div ref={searchRef} style={{ position: 'relative' }}>
          <label className="form-label">Patient <span className="required">*</span></label>
          <div className="search-input-wrap" style={{ maxWidth: '100%' }}>
            <span className="search-icon"><Icon name="search" size={15} /></span>
            <input
              className="search-input"
              style={{ maxWidth: '100%', paddingRight: searchLoading ? 36 : 12 }}
              placeholder="Search patient by name or phone…"
              value={patientQuery}
              onChange={e => { setPatientQuery(e.target.value); setError(''); }}
              autoFocus
            />
            {searchLoading && (
              <div style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)' }}>
                <div className="spinner" style={{ width: 16, height: 16, borderWidth: 2 }} />
              </div>
            )}
          </div>

          {showDropdown && (
            <div style={{
              position: 'absolute', top: '100%', left: 0, right: 0,
              background: 'var(--bg-surface)', borderRadius: 'var(--radius-md)',
              border: '1.5px solid var(--border)', boxShadow: 'var(--shadow-lg)',
              zIndex: 9999, maxHeight: 300, overflowY: 'auto', marginTop: 4,
            }}>
              {patientResults.length === 0 ? (
                <div style={{ padding: '16px', fontSize: 13, color: 'var(--text-muted)', textAlign: 'center' }}>
                  No patients found for "{patientQuery}"
                </div>
              ) : patientResults.map(p => (
                <div
                  key={p.id}
                  onClick={() => { setSelectedPatient(p); setShowDropdown(false); setPatientQuery(''); }}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 12,
                    padding: '11px 16px', cursor: 'pointer',
                    borderBottom: '1px solid var(--bg-subtle)',
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-hover)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                >
                  <div style={{
                    width: 36, height: 36, borderRadius: '50%',
                    background: 'var(--blue-bg)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                    fontSize: 13, fontWeight: 700, color: 'var(--brand-blue)', flexShrink: 0,
                  }}>
                    {p.firstName?.[0]}{p.lastName?.[0]}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: 13 }}>{p.firstName} {p.lastName}</div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 1 }}>
                      {[displayPatientCode(p.patientCode), p.phone].filter(Boolean).join(' · ')}
                    </div>
                  </div>
                  <span
                    className={`badge badge-${p.status === 'ACTIVE' ? 'active' : 'pending'}`}
                    style={{ fontSize: 10 }}
                  >
                    {p.status || 'Active'}
                  </span>
                </div>
              ))}
            </div>
          )}

          {patientQuery.length > 0 && patientQuery.length < 2 && (
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 6, paddingLeft: 4 }}>
              Type at least 2 characters to search
            </div>
          )}
        </div>
      )}
    </div>
  );
}
